import { Spin } from 'antd';
import { BlockLoader } from 'components/atoms/BlockLoader';
import { PriceBookControls } from 'components/organisms/PriceBookControls';
import { PriceBookEntriesTable } from 'components/organisms/PriceBookEntriesTable';
import { useLocation, useParams } from 'react-router-dom';
import { useGetBusinessQuery, useGetDivisionQuery } from 'redux/services/abbyCadabby/abbyCadabbyApi';
import { useGetPriceBookEntriesQuery } from 'redux/services/julia/juliaApi';
import { setPriceBookOffset, setPriceBookTake } from 'redux/services/julia/priceBookEntryParams';
import { useAppDispatch, useAppSelector } from 'redux/store';

export const PriceBookEntriesPage = (): JSX.Element => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { juliaPriceBookEntryParams } = useAppSelector((state) => state);

  const isDivisionContext = location.pathname.includes('division/');

  const { data: business } = useGetBusinessQuery(id as string, { skip: !id || isDivisionContext });
  const { data: division } = useGetDivisionQuery(id as string, { skip: !id || !isDivisionContext });

  const dataAreaId = isDivisionContext ? division?.business?.dataAreaId : business?.dataAreaId;
  const businessId = isDivisionContext ? division?.business?.id : business?.id;

  const {
    data: response,
    isLoading,
    isFetching
  } = useGetPriceBookEntriesQuery({ dataAreaId: dataAreaId || '', businessId: businessId || '', params: juliaPriceBookEntryParams }, { skip: !dataAreaId || !businessId });

  const handlePageChange = (page: number, pageSize: number): void => {
    dispatch(setPriceBookTake(pageSize));
    dispatch(setPriceBookOffset((page - 1) * pageSize));
  };

  const tableLoading = {
    spinning: isLoading || (isFetching && juliaPriceBookEntryParams.offset === 0),
    indicator: <BlockLoader direction="loader loader--slideUp" />
  };

  return (
    <Spin spinning={isLoading} indicator={<BlockLoader direction="loader loader--slideUp" />}>
      <PriceBookControls isReadOnly={isDivisionContext} />
      <PriceBookEntriesTable
        isReadOnly={isDivisionContext}
        loading={tableLoading}
        dataSource={response?.data}
        pagination={{
          total: response?.totalCount,
          defaultPageSize: juliaPriceBookEntryParams.take,
          onChange: handlePageChange,
          pageSizeOptions: ['10', '20', '25', '50', '100']
        }}
      />
    </Spin>
  );
};
